import { LiveChatProvider } from "types/api"

import { FormState } from "./types"

export const DEFAULT_INHOUSE_HOST = "https://inter.igaming-rgs.xyz"

export const EXAMPLE_WORKSPACE_KEY = "cmtx97pl6000fqawe92smrzks"

/** "" is the unconfigured state: the frontend keeps selecting the provider from its own env. */
export const PROVIDER_VALUES: (LiveChatProvider | "")[] = ["", "none", "intercom", "tawk", "inhouse"]

export const POSITION_VALUES: FormState["position"][] = ["br", "bl"]

export const INITIAL_FORM: FormState = {
  provider: "",
  intercomAppId: "",
  intercomHashKey: "",
  tawkPropertyId: "",
  tawkWidgetId: "",
  tawkApiKey: "",
  inhouseHost: "",
  inhousePublicKey: "",
  inhouseHashSecret: "",
  desktopOnly: true,
  hideOnSportsbook: false,
  position: "br",
  horizontalPadding: "",
  sportsbookHorizontalPadding: "",
  verticalPadding: ""
}
